var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlluBgClique(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571.81 492.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19f59b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_Clique") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M479.1,124.06c3.13,42.69,22.87,82,42.64,119.81s40.31,76.49,45.3,119S557.71,453.23,521.53,475c-32.26,19.4-73.28,13.95-109,2.43-57.29-18.48-109.27-50.5-163-78S177,369.18,116,361.18c-8.1-1.06-54.55-11.81-62.2-14.75-8-3.08-14.3-9.61-19.72-16.39-38-47.52-43.51-124.22-1.38-168C55.6,138.26,88,127.2,119.1,116.93L233,79.31C268.42,67.63,304.63,55.5,333.78,32,347,21.32,359.25,8.08,375.61,4.16c19.19-4.6,53.67,4.68,66.39,20s28.72,39.39,33,59Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluBgClique);
export default __webpack_public_path__ + "static/media/illu_bg_clique.c52e824fa8c7b5f70261822e5367e96b.svg";
export { ForwardRef as ReactComponent };